import './style.css'
import { createApp } from 'vue'
import vueDebounce from 'vue-debounce'
import {
    VueFire,
    VueFireDatabaseOptionsAPI,
    VueFireFirestoreOptionsAPI,
} from 'vuefire'
import { firebaseApp } from './modules/firebase'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import App from './App.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import BadgeDirective from 'primevue/badgedirective'
import VueLazyload from 'vue-lazyload'
import { VueQueryPlugin } from '@tanstack/vue-query'

import 'iconify-icon'

import { createPinia } from 'pinia'
import VueKonva from 'vue-konva'

import { router } from './router'
import { baseTheme } from './theme'
// Registers window.__offerTrace. Imported here so the console helper exists
// from boot rather than only once the assignment route chunk has loaded.
import './lib/diagnostics/offerModalTrace'
import './components/dashboards/customer-service/legacy-storage'

declare module 'vue-router' {
    interface RouteMeta {
        title: string
        reuseOnParamChange?: boolean
        icon?: string
        sidebarOrder?: number
        sidebarLabel?: string
        sidebarQuery?: Record<string, string>
        sidebarGroup?: string
        requiresApplication?: string
        requiresRole?: string | string[]
    }
}

// Creating Vue App
const app = createApp(App)
const pinia = createPinia()

// Registering Global Plugins & Components
console.log('REGISTERING GLOBAL PLUGINS')
app.use(router)
    .use(PrimeVue, {
        theme: {
            preset: baseTheme,
            options: {
                darkModeSelector: 'light',
                cssLayer: {
                    name: 'primevue',
                    order: 'theme,base,primevue',
                },
            },
        },
    })
    .use(ToastService)
    .use(ConfirmationService)
    .use(VueFire, {
        firebaseApp,
        modules: [VueFireFirestoreOptionsAPI(), VueFireDatabaseOptionsAPI()],
    })
    .use(autoAnimatePlugin)
    .use(VueLazyload, {
        preLoad: 1.3,
        loading: '/loading-image.gif',
        attempt: 1,
    })
    .use(pinia)
    .use(VueKonva)
    .use(VueQueryPlugin)

// Registering Global Directives
console.log('REGISTERING GLOBAL DIRECTIVES')
app.directive('tooltip', Tooltip)
    .directive('badge', BadgeDirective)
    .directive('debounce', vueDebounce({ lock: true }))

// Mounting the App
app.mount('#app')
